module.exports = __webpack_public_path__ + "static/Resume-3dc29f9382717a12f15321e2bca3cc47.pdf";